import type { ReactNode } from 'react';
import { LabsChip } from '@frameio/shared/components/LabsChip';
import { IconButton2, Text } from '@frameio/vapor';
import { IconX } from '@frameio/vapor-icons';
import styles from './DialogHeader.module.css';
import TEXT from './generated/TEXT/DialogHeader';

type DialogHeaderProps = {
  title: string;
  subtitle: ReactNode;
  onClose: () => void;
  closeLabel: string;
};

TEXT.DEFINE({
  labsTooltipTitle:
    'This feature is in early development and may change or be discontinued.',
  labsTooltipDetails: 'Click to Submit Feedback',
});

export const DialogHeader = ({
  title,
  subtitle,
  onClose,
  closeLabel,
}: DialogHeaderProps) => (
  <div className={styles.header}>
    <div className={styles.headerRow}>
      <div className={styles.titleGroup}>
        <Text variant="header">{title}</Text>
        <LabsChip
          clickAction="feedback"
          lab="firefly_actions"
          tooltip={{
            details: TEXT.labsTooltipDetails,
            title: TEXT.labsTooltipTitle,
          }}
        />
      </div>
      <IconButton2
        icon={<IconX />}
        label={closeLabel}
        onPress={onClose}
        size="small"
        variant="tertiary"
      />
    </div>
    <Text color="secondary" variant="body">
      {subtitle}
    </Text>
  </div>
);
